export const mgPlatformArrowLeftIcon = {
  data: `<svg viewBox="0 0 10 17" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M8.82996 15.51L1.32996 8.01001L8.82996 0.51001" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'arrow-left'
}
